/**
 * An object representing the paths for different screens in the application.
 *
 * @constant {Object}
 * @property {string} home - The path for the home screen.
 */
export const screens = {
  home: "/",
};
